<template>
  <el-tooltip effect="dark" placement="top" v-if="updatedUser || createdUser">
    <div slot="content" style="width: 260px" v-html="getUsersInfo"></div>
    <em
      :class="`fa fa-user-secret ${mt}`"
      style="cursor: help"
      aria-hidden="true"
    ></em>
  </el-tooltip>
</template>
<script>
import i18n from 'src/i18n';

export default {
  name: 'user-operation-info',
  props: {
    createdUser: {
      type: String,
      default: null,
    },
    updatedUser: {
      type: String,
      default: null,
    },
    mt: {
      type: String,
      default: 'mt-1',
    },
  },
  computed: {
    getUsersInfo() {
      try {
        const uCreated = this.createdUser
          ? `${i18n.t('common_words.created_user')}: <br/><b>${
              this.createdUser
            }</b>`
          : '';

        const uUpdated = this.updatedUser
          ? `${i18n.t('common_words.updated_user')}: <br/><b>${
              this.updatedUser
            }</b>`
          : '';

        return `${uCreated}<br/><br/>${uUpdated}`;
      } catch (error) {
        return '';
      }
    },
  },
};
</script>
